import { combineReducers } from '@reduxjs/toolkit';

import { reducer as agentsPageReducer } from './agentPage';
import { reducer as banksPageReducer } from './banksPage';
import { reducer as blackListPageReducer } from './blackListPage';
import { reducer as cardsPageReducer } from './cardsPage';
import { reducer as clientsPageReducer } from './clientsPage';
import { reducer as correctionsPageReducer } from './correctionsPage';
import { reducer as cryptoWalletsPageReducer } from './cryptoWalletsPage';
import { reducer as debtorsPageReducer } from './debtorsPage';
import { reducer as devicesPageReducer } from './devicesPage';
import { reducer as greyListPageReducer } from './greyListPage';
import { reducer as holdersPageReducer } from './holdersPage';
import { reducer as incomesPageReducer } from './incomesPage';
import { reducer as notificationsPageReducer } from './notificationsPage';
import { reducer as operatorsPageReducer } from './operatorsPage';
import { reducer as outcomesPageReducer } from './outcomePage';
import { reducer as providersPageReducer } from './providersPage';
import { reducer as requestLogsPageReducer } from './requestLogsPage';
import { reducer as statsReducer } from './stats';
import { reducer as tariffPageReducer } from './tariffPage';
import { reducer as tradersPageReducer } from './tradersPage';
import { reducer as transactionsPageReducer } from './transactionsPage';
import { reducer as userDataReducer } from './userData';
import { reducer as usersPageReducer } from './usersPage';

export default combineReducers({
  agentsPage: agentsPageReducer,
  banksPage: banksPageReducer,
  blackListPage: blackListPageReducer,
  cardsPage: cardsPageReducer,
  clientsPage: clientsPageReducer,
  correctionsPage: correctionsPageReducer,
  cryptoWalletsPage: cryptoWalletsPageReducer,
  debtorsPage: debtorsPageReducer,
  devicesPage: devicesPageReducer,
  greyListPage: greyListPageReducer,
  holdersPage: holdersPageReducer,
  incomesPage: incomesPageReducer,
  notificationsPage: notificationsPageReducer,
  operatorsPage: operatorsPageReducer,
  outcomesPage: outcomesPageReducer,
  providersPage: providersPageReducer,
  requestLogsPage: requestLogsPageReducer,
  stats: statsReducer,
  tariffsPage: tariffPageReducer,
  tradersPage: tradersPageReducer,
  transactionsPage: transactionsPageReducer,
  userData: userDataReducer,
  usersPage: usersPageReducer
});
